import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adminvideoayuda',
  templateUrl: './adminvideoayuda.component.html',
  styleUrls: ['./adminvideoayuda.component.scss']
})
export class AdminvideoayudaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/adminvideoayuda/adminvideoayuda.component.ts